import React from 'react';
import { FieldError } from '@spike/model';
import { useSingleSaleHeaderStyles } from 'components/Payments/SingleSale/Header/SingleSaleHeader.styles';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';
import Title from 'components/Payments/ui/Title';
import { SearchClient } from 'components/Payments/SingleSale/SearchClient/SearchClient';
import ClientInfo from 'components/Payments/SingleSale/ClientInfo/ClientInfo';
import Client from '@spike/client-model';

interface SingleSaleHeaderProps {
    errors: Array<FieldError>;
    className?: string;
    data: Client;
    onAddNewClient: () => void;
    onClientSelected: (clientID: number | undefined) => void;
}

export const SingleSaleHeader: React.FC<SingleSaleHeaderProps> = props => {
    const classes = useSingleSaleHeaderStyles();

    const hasError = React.useMemo(() => props.errors?.some(error => error.fieldName === 'client'), [props.errors]);

    return (
        <div className={classes.root}>
            <Grid
                container
                className={clsx(classes.container)}
            >
                <Grid
                    item
                    xs={12}
                    md={4}
                    xl={3}
                    className={clsx(classes.containerSearch, { [classes.errorBorder]: hasError }, props.className)}
                >
                    <div>
                        <Title text="New Sale" />
                    </div>
                    <div className={classes.boxSearch}>
                        <SearchClient
                            parentName={props.data ? `${props.data.firstName} ${props.data.lastName}` : undefined}
                            onAddClient={props.onAddNewClient}
                            onSelectClient={props.onClientSelected}
                        />
                    </div>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={5}
                >
                    {props.data && <ClientInfo data={props.data} />}
                </Grid>
            </Grid>
        </div>
    );
};
